// App.js (updated)
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Homepage from './pages/Homepage';
import AllChargingStations from './pages/AllChargingStations';
// import AllSessions from './pages/AllSessions';
import ActiveSessions from './pages/ActiveSessions';
import DashboardLayout from './components/DashboardLayout';
import StationDetails from './pages/StationDetails';
import Vehicles from './pages/Vehicles';
import Users from './pages/Users';
import CustomToaster from './components/CustomToaster';

import WebSocketProvider from './contexts/WebSocketProvider';
import { DataProvider } from './contexts/DataProvider';
import AuthProvider, { useAuth } from './contexts/Auth/AuthProvider.jsx';
import LoginPage from './auth/Login';
import PaymentTransactions from './pages/PaymentTransactions.jsx';
import ChargingSessions from './pages/ChargingSessions.jsx';
import WalletTransactions from './pages/WalletTransactions.jsx';
import VehicleBalances from './components/VehicleBalances.jsx';
import VehicleBalanceTransactions from './pages/VehicleBalanceTransactions.jsx';
import Refunds from './pages/Refunds.jsx';
import QrCodePayments from './pages/QrCodePayments.jsx';
import WorkInProgress from './components/WorkInProgress.jsx';
import ForgotPassword from './components/ForgotPassword.jsx';
import ChargingSessionsPage from './pages/ChargingSessionsPage.jsx';
import WalletsPage from './pages/WalletsPage.jsx';
import DaywiseStationGroup from './pages/DaywiseStationGroup.jsx';
import AllUsers from './pages/AllUsers.jsx';
import UserPaymentTransactions from './components/UserPaymentTransactions.jsx';
import PaymentCharigingSessions from './components/PaymentCharigingSessions.jsx';
import AddMissingTransaction from './components/AddMissingTransaction.jsx';
import OTAMonitoringPage from './components/OTAMonitoringPage.jsx';
import HeartbeatDashboard from './components/StationDisplayData/HeartbeatDashboard.jsx';
import Settlement from './pages/Settlement.jsx';
import Rfid from './pages/Rfid.jsx';
import Analytics from './pages/Analytics.jsx';
import LiveCharging from './pages/LiveCharging.jsx';
import FinancialReconciliation from './pages/FinancialReconciliation';
import StationManagement from './pages/StationManagement.jsx';

// PrivateRoute wrapper to protect routes
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Wait for auth to resolve before deciding
  if (loading) return null;

  return user
    ? children
    : <Navigate to="/login" replace state={{ from: location }} />;
};
// (Don't read groupId at module scope — read it inside App so routing matches runtime localStorage)

// PublicRoute wrapper for public routes (like login)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Wait for auth to resolve before deciding
  if (loading) return null;

  // If already logged in, go back to intended page or home
  const redirectTo = location.state?.from?.pathname || '/';
  return !user ? children : <Navigate to={redirectTo} replace />;
};

function App() {
  const groupId = localStorage.getItem("group_id");
  // helpful for debugging during development
  // console.log('groupId (App):', groupId);
  return (
    <WebSocketProvider>
      <AuthProvider>
        <DataProvider>
          <Router>
            <div className="App min-h-screen md:overflow-x-visible overflow-x-hidden">
              <CustomToaster />
              <Routes>
                <Route 
                  path="/login" 
                  element={
                    <PublicRoute>
                      <LoginPage />
                    </PublicRoute>
                  } 
                />

                

                <Route path="/" element={
                  <PrivateRoute>
                    <DashboardLayout />
                  </PrivateRoute>
                }>
                  <Route index element={<Homepage />} />
                  <Route path="analytics" element={<Analytics />} />
                  <Route path="live-charging" element={<LiveCharging />} />
                  <Route path="charging-stations" element={<AllChargingStations />} />
                  <Route path="active-sessions" element={<ActiveSessions />} />
                  <Route path="users" element={<Users />} />
                  
                  <Route path="vehicle-balances" element={<VehicleBalances />} />
                  <Route path="vehicle-balance-transactions" element={<VehicleBalanceTransactions />} />
                  <Route path="refunds" element={<Refunds />} />
                  <Route path="qr-transactions" element={<QrCodePayments />} />
                  <Route path="roles" element={<WorkInProgress />} />
                  <Route path="permissions" element={<WorkInProgress />} />
                  <Route path="discounts" element={<WorkInProgress />} />
                  <Route path="vehicles" element={<WorkInProgress />} />
                  <Route path="payment-gateways" element={<WorkInProgress />} /> 
                  <Route path="reports" element={<WorkInProgress />} />
                  <Route path="Logs" element={<WorkInProgress />} />
                  <Route path="settings" element={<WorkInProgress />} />
                  <Route path="alerts" element={<WorkInProgress />} />
                  <Route path="charging-stations/:stationId" element={<StationDetails />} />
                  <Route path="payment-transactions/:userId" element={<UserPaymentTransactions />} />
                  <Route path="charging-sessions/:sessionId" element={<PaymentCharigingSessions />} />
                  <Route path="group-by-station" element={<DaywiseStationGroup />} />
                  <Route path="/payment-transactions/:userId/add" element={<AddMissingTransaction />}/>
                  <Route path="settlement" element={<Settlement />} />
                  <Route path="/rfid" element={<Rfid />} />
                  {/* <Route path="charging-sessions" element={<ChargingSessionsPage />} /> 
                  <Route path="wallets" element={<WalletsPage />} /> 
                  <Route path="payment-transactions" element={<PaymentTransactions />} />
                  <Route path="wallet-transactions" element={<WalletTransactions />} /> */}

                  {groupId === '1' && (
                        <>
                          <Route path="charging-sessions" element={<ChargingSessionsPage />} />
                          <Route path="wallets" element={<WalletsPage />} />
                          <Route path="payment-transactions" element={<PaymentTransactions />} />
                          <Route path="wallet-transactions" element={<WalletTransactions />} />
                          <Route path="financial-reconciliation" element={<FinancialReconciliation />} />
                          <Route path="station-management" element={<StationManagement />} />
                          <Route path="all-users" element={<AllUsers />} />
                          <Route path="ota-monotoring" element={<OTAMonitoringPage />} />
                          <Route path="HeartbeatDashboard" element={<HeartbeatDashboard />} />
                        </>
                      )}



                  
                </Route>

                {/* Redirect unknown routes appropriately */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </DataProvider>
      </AuthProvider>
    </WebSocketProvider>
  );
}

export default App;